import { render } from "./inventoryList.vue?vue&type=template&id=06531c81&scoped=true"
import script from "./inventoryList.vue?vue&type=script&lang=js"
export * from "./inventoryList.vue?vue&type=script&lang=js"

import "./inventoryList.vue?vue&type=style&index=0&id=06531c81&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-06531c81"

export default script